import { takeEvery } from 'redux-saga/effects';

import * as profileActions from 'store/modules/profile/actionTypes';
import { setPushSubscription } from './utils';

export default function* listenSetPushSubscription() {
  yield takeEvery(profileActions.SET_PUSH_SUBSCRIPTION, setPushSubscription);
}
